export var LoginType;
(function (LoginType) {
    LoginType[LoginType["Popup"] = 0] = "Popup";
    LoginType[LoginType["Redirect"] = 1] = "Redirect";
})(LoginType || (LoginType = {}));
//# sourceMappingURL=LoginType.js.map